import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import BankTxnListUI from '../../components/finapp/bankAccount/BankTxnListUI'
import TransactionHeaderUI from '../../components/finapp/paymentCard/TransactionHeaderUI'

const BankTxnListPageUI = ({context, messageList, errorList, txnList, filteredTxnList,
    alphaSort, timeSort, searchFilter,
    onRefreshClick, onAlphaSortClick, onTimeSortClick, onSearchFilterChange
  }) =>
  <PrivatePageSF context={context} className='pg_card_txns'
    messageList={messageList} headerMessageKey='c_card_txns'
    centered={(!txnList && !errorList) || (txnList && txnList.length === 0)}
  >
    {
      !txnList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      txnList && txnList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={false}
        createDisabledMessageKey='c_no_txn_msg'
      />
    }
    {
      txnList && txnList.length !== 0 &&
      <div>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_card_txns' />
        <TransactionHeaderUI context={context} messageList={messageList} />
        <BankTxnListUI
          context={context}
          txnList={filteredTxnList}
          messageList={messageList}
          alphaSort={alphaSort}
          timeSort={timeSort}
          searchFilter={searchFilter}
          // events
          onRefreshClick={onRefreshClick}
          onAlphaSortClick={onAlphaSortClick}
          onTimeSortClick={onTimeSortClick}
          onSearchFilterChange={onSearchFilterChange}
        />
      </div>
    }
  </PrivatePageSF>

export default BankTxnListPageUI
